/**
=========================================================
* Annotation Portal React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Annotation Portal React.
 * You can add new color using this file.
 * You can customized the colors for the entire Annotation Portal React using thie file.
 */

const colors = {
  background: {
    default: "#f6f7fb",
  },

  text: {
    main: "#5b6478",
    focus: "#5b6478",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#6366f1",
    focus: "#4f46e5",
  },

  secondary: {
    main: "#64748b",
    focus: "#7c8aa0",
  },

  info: {
    main: "#4f6bed",
    focus: "#3f58d4",
  },

  success: {
    main: "#16a34a",
    focus: "#22b85a",
  },

  warning: {
    main: "#f59e0b",
    focus: "#fbae2e",
  },

  error: {
    main: "#ef4444",
    focus: "#f36060",
  },

  light: {
    main: "#f1f3f9",
    focus: "#f1f3f9",
  },

  dark: {
    main: "#1e293b",
    focus: "#0f172a",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#818cf8",
      state: "#4f46e5",
    },

    secondary: {
      main: "#7c8aa0",
      state: "#475569",
    },

    info: {
      main: "#6d8cf5",
      state: "#4f6bed",
    },

    success: {
      main: "#34d399",
      state: "#16a34a",
    },

    warning: {
      main: "#fbbf24",
      state: "#f59e0b",
    },

    error: {
      main: "#f87171",
      state: "#ef4444",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#1e293b",
      state: "#0f172a",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d5dbe6",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
